import {
  CustomRecurrenceFrequency,
  DocumentReference,
  IRecurrencePattern,
  ISoftDelete,
  Time24hrType,
  Timestamp,
} from '@principle-theorem/shared';
import { IBrand } from '../brand';
import { IPractice } from '../practice/practice';
import { ICustomReport } from '../reports/custom-report';
import { TemplateScope } from '../templating/template-scope';
import { IMarketingCampaignRun } from './campaign-run';
import {
  IMarketingCampaignStep,
  MarketingCampaignStepConversionType,
} from './campaign-step';

export enum MarketingCampaignCollection {
  MarketingCampaignRuns = 'marketingCampaignRuns',
  MarketingCampaignSteps = 'marketingCampaignSteps',
  MarketingCampaignEntries = 'marketingCampaignEntries',
  BulkActions = 'bulkActions',
}

export enum MarketingCampaignStatus {
  Draft = 'draft',
  Active = 'active',
  Paused = 'paused',
  Completed = 'completed',
}

export enum MarketingCampaignPauseReason {
  UserInitiated = 'userInitiated',
  InsufficientFunds = 'insufficientFunds',
}

export enum MarketingCampaignType {
  GeneralNotice = 'generalNotice',
  Marketing = 'marketing',
}

export interface ICampaignEntryResetRules {
  multipleEntry: boolean;
  reentryScope?: MarketingCampaignScope;
  frequencyCount: number;
  frequencyType: CustomRecurrenceFrequency;
  maxEntryCount?: number;
}

export type MarketingCampaignScope =
  | TemplateScope.Patient
  | TemplateScope.Invoice
  | TemplateScope.Appointment;

export const ALLOWED_MARKETING_CAMPAIGN_SCOPES: MarketingCampaignScope[] = [
  TemplateScope.Patient,
  TemplateScope.Invoice,
  TemplateScope.Appointment,
];

export interface IMarketingCampaign extends ISoftDelete {
  name: string;
  status: MarketingCampaignStatus;
  steps: DocumentReference<IMarketingCampaignStep>[];
  recurrencePattern?: IRecurrencePattern;
  recurrenceRunTime?: Time24hrType;
  nextRunAt?: Timestamp;
  nextRunRef?: DocumentReference<IMarketingCampaignRun>;
  type: MarketingCampaignType;
  scope: MarketingCampaignScope;
  entryResetRules: ICampaignEntryResetRules;
  customReportRef?: DocumentReference<ICustomReport>;
  dismissedCustomReportPrompt?: boolean;
  brandRef: DocumentReference<IBrand>;
  practiceRef: DocumentReference<IPractice>;
  conversionType?: MarketingCampaignStepConversionType;
  maximumEntriesPerRun?: number;
  pauseReason?: MarketingCampaignPauseReason;
}
